import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#ed6c84', // #E53935
                secondary: '#ed6c84', // #FFCDD2
                accent: '#ed6c84', // #3F51B5
            },
        },
        dark: false
    },
})
